<script setup lang="ts">
import { Yield } from '@sonarwatch/portfolio-core';
import { percentFormat } from '../helpers/percentFormat';
import { useAppStore } from '@/store/app';
const appStore = useAppStore();
const props = defineProps<{
  yields?: Yield[];
}>();
const apy =
  props.yields && props.yields.length > 0
    ? props.yields.reduce((sum: number, currYield) => {
        return sum + currYield.apy;
      }, 0)
    : null;
const apyString = apy !== null ? percentFormat(Math.abs(apy)) : null;
const color = !apy
  ? undefined
  : apy > 0
  ? `green-${appStore.isDark ? 'lighten' : 'darken'}-1`
  : `red-${appStore.isDark ? 'lighten' : 'darken'}-1`;
</script>

<template>
  <v-chip v-if="apyString" :color="color">
    {{ apyString }}
  </v-chip>
</template>
